<template>
  <div class="sds-updated">
    <div class="sds-updated__filter">
      <div class="sds-updated__search">
        <input
          v-model="query"
          type="text"
          class="sds-updated__search-input"
          placeholder="Search..."
          aria-label="Search safety data sheets"
        >
        <button
          v-if="query"
          type="button"
          class="sds-updated__search-clear"
          aria-label="Clear search"
          @click="query = ''"
        >
          &times;
        </button>
      </div>

      <div class="sds-updated__tabs">
        <button
          class="sds-updated__tab"
          :class="{ 'is-active': activeFilter === 'all' }"
          @click="activeFilter = 'all'"
        >
          All
        </button>
        <button
          v-for="cat in data"
          :key="cat.cat_title"
          class="sds-updated__tab"
          :class="{ 'is-active': activeFilter === cat.cat_title }"
          @click="activeFilter = cat.cat_title"
        >
          {{ cat.cat_title }}
        </button>
      </div>
    </div>

    <div class="sds-updated__cats">
      <section
        v-for="cat in visibleCategories"
        :key="cat.cat_title"
        class="sds-updated__cat"
        :class="{ 'sds-updated__cat--banner': isBanner(cat) }"
      >
        <div
          v-if="isBanner(cat)"
          class="sds-updated__banner"
        >
          <div class="sds-updated__banner-bg">
            <img
              v-if="cat.background"
              :src="cat.background"
              alt=""
            >
          </div>
          <div class="sds-updated__banner-inner">
            <h2 class="sds-updated__banner-title">
              {{ cat.cat_title }}
            </h2>
            <p
              v-if="cat.description"
              class="sds-updated__banner-desc"
            >
              {{ cat.description }}
            </p>
          </div>
        </div>

        <div
          v-else
          class="sds-updated__header"
        >
          <h2 class="sds-updated__title">
            {{ cat.cat_title }}
          </h2>
          <p
            v-if="cat.description"
            class="sds-updated__desc"
          >
            {{ cat.description }}
          </p>
        </div>

        <div
          v-if="isBanner(cat)"
          class="sds-updated__list"
        >
          <a
            v-for="(item, i) in cat.items"
            :key="i"
            class="sds-updated__row"
            :href="item.link"
            target="_blank"
            rel="noopener"
          >
            <span class="sds-updated__row-title">{{ item.title }}</span>
            <span class="sds-updated__row-cta">Download PDF &gt;</span>
          </a>
        </div>

        <div
          v-else
          class="sds-updated__grid"
        >
          <a
            v-for="(item, i) in cat.items"
            :key="i"
            class="sds-updated__card"
            :href="item.link"
            target="_blank"
            rel="noopener"
          >
            <span
              v-if="item.formula"
              class="sds-updated__chip"
            >
              <template
                v-for="(part, p) in formulaParts(item.formula)"
                :key="p"
              >
                <sub v-if="part.sub">{{ part.text }}</sub>
                <template v-else>{{ part.text }}</template>
              </template>
            </span>
            <span class="sds-updated__card-body">
              <span class="sds-updated__card-title">{{ item.title }}</span>
              <span class="sds-updated__card-swap">
                <span
                  v-if="item.subtitle"
                  class="sds-updated__card-sub"
                >{{ item.subtitle }}</span>
                <span class="sds-updated__card-btn">Download PDF</span>
              </span>
            </span>
          </a>
        </div>
      </section>
    </div>

    <p
      v-if="!visibleCategories.length"
      class="sds-updated__empty"
    >
      No results found.
    </p>
  </div>
</template>

<script>
export default {
  name: 'SdsUpdated',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeFilter: 'all',
      query: '',
    };
  },
  computed: {
    visibleCategories() {
      const q = this.query.trim().toLowerCase();

      return this.data
        .filter((cat) => this.activeFilter === 'all' || cat.cat_title === this.activeFilter)
        .map((cat) => ({
          ...cat,
          items: (cat.items || []).filter((item) => {
            if (!q) return true;
            return [item.title, item.subtitle, item.formula]
              .filter(Boolean)
              .some((text) => String(text).toLowerCase().includes(q));
          }),
        }))
        .filter((cat) => cat.items.length > 0);
    },
  },
  methods: {
    isBanner(cat) {
      return cat.layout === 'banner';
    },
    // Split a plain formula like "C4H6" into text/subscript parts so it can be
    // rendered with real <sub> nodes and escaped interpolation (no v-html sink).
    formulaParts(formula) {
      if (!formula) return [];
      return String(formula)
        .split(/(\d+)/)
        .filter((part) => part !== '')
        .map((part) => ({ text: part, sub: /^\d+$/.test(part) }));
    },
  },
};
</script>
